import InternalTicketsTables from '@/features/InternalTicketsTables';

import useStyles from './DashboardInternal.styles';

const DashboardInternal = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.dashboardInternal}>
      <InternalTicketsTables />
    </div>
  );
};
export default DashboardInternal;
